import React, { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ListDemeterChartsResponse } from '../../../Generated/Raven-Demeter';
import NavigationRoutes from '../../../Layouts/NavigationRoutes';
import PageHeader from '../../Components/Headers/PageHeader';
import OverflowCellWithTooltip from '../../Components/Tables/OverflowCellWithTooltip/OverflowCellWithTooltip';
import Table from '../../Components/Tables/Table/Table';
import TableWrapper from '../../Components/Tables/TableWrapper/TableWrapper';
import browserService from '../../Services/BrowserService';
import useLanguage from '../../Services/Language/useLanguageHook';
import styles from './ChartBuilder.module.scss';
import ChartBuilderCreateChartAction from './ChartBuilderActions/ChartBuilderCreateChartAction';
import ChartBuilderListActions from './ChartBuilderActions/ChartBuilderListActions';
import { listChartsTableHeaders, ListChartTableRow } from './ChartBuilderDefinitions';

const defaultMinimumTableWidth = 700;

interface IChartBuilderPageProps {
    listDemeterChartsResponse: ListDemeterChartsResponse;
    refreshListDemeterCharts: () => void;
}

const ChartBuilderPage: React.FC<IChartBuilderPageProps> = (props: IChartBuilderPageProps) => {
    // Application hooks.
    const [translations] = useLanguage();

    const listChartsTableRows: ListChartTableRow[] = useMemo(() => {
        if (!props.listDemeterChartsResponse?.rows) {
            return [];
        }

        return props.listDemeterChartsResponse.rows.map((x) => ({
            chartName: (
                <OverflowCellWithTooltip
                    nonTooltipOverrideValue={
                        <Link className={styles.chart_builder_list_action} to={`${NavigationRoutes.ChartBuilder}/${x.demeterChartGuid}/edit`}>
                            {x.name}
                        </Link>
                    }
                    value={x.name}
                />
            ),
            modifiedAt: x.modifiedAt ?? '',
            modifiedBy: x.modifiedBy ?? '',
            actions: <ChartBuilderListActions demeterChartGuid={x.demeterChartGuid} refreshListDemeterCharts={props.refreshListDemeterCharts} />,
        }));
    }, [props.listDemeterChartsResponse]);

    useEffect(() => {
        browserService.scrollUp();
    }, []);

    const loading = !props.listDemeterChartsResponse;

    return (
        <div className={styles.chart_builder_list_page_container}>
            <PageHeader title={translations.chartBuilder.headers.myCharts} />
            <TableWrapper
                headerOptions={{
                    containerClassName: styles.chart_builder_list_table_container,
                }}
                isLoading={loading}
                rightSide={<ChartBuilderCreateChartAction />}
                track={{ eventCategory: 'ChartBuilder', eventAction: 'ListCharts' }}
            >
                <Table
                    tableHeaders={listChartsTableHeaders}
                    tableData={listChartsTableRows!}
                    tableStyle="alternatingRows"
                    minimumTableWidth={defaultMinimumTableWidth}
                />
            </TableWrapper>
        </div>
    );
};

export default ChartBuilderPage;
